import youtubeApi from './app/components/YoutubeLoader';
import SoundPlayer from './app/Sounds';
import Home from './sections/Home';

import './styles/app.scss';
import preloader from './utils/Preloader';
import sectionControl from './app/SectionControl';
import About from './sections/About';
import Carol from './sections/Carol';
import Skrull from './sections/Skrull';
import Fury from './sections/Fury';
import Guestbook from './sections/Guestbook';
import Kree from './sections/Kree';
import Multimedia from './sections/Multimedia';
import Footer from './sections/Footer';
import Resizer from './utils/Resizer';
import Sounds from './app/Sounds';
import Preloader from './utils/Preloader';

class App {
  constructor() {}

  async init() {
    Resizer.init({
      targets: [
        {
          label: 'window',
          target: window,
        },
      ],
    });
    this.setReleaseDate(settings.dates, settings);
    this.initFocusBlur();

    if (settings.sounds.enabled) {
      SoundPlayer.init({
        soundList: settings.sounds.files,
      });

      SoundPlayer.playSound('music');
      SoundPlayer.addEventListener('change', this.onSoundChange.bind(this));
    }

    await youtubeApi.download();
    await this.loadSite();

    this.initSite();
    // this.enterSite();
  }

  loadSite() {
    preloader.init();
    this.files = Object.values(settings.sections).reduce(
        (list, section) => (section.enabled && section.preloadFiles ? list.concat(section.preloadFiles) : list),
        settings.framework.preloadFiles
    );

    return preloader.load(this.files);
  }

  initSite() {
    this.files.forEach((file) => {
      if (typeof file === 'object' && file.type === 'template') {
        let fileData = Preloader.getFile(file.id);
        fileData = fileData.replace(/src\=\"assets/g, `src="${window.dataSrc}assets`);
        Preloader.updateFile(file.id, fileData);
      }
    });

    sectionControl.init({
      firstSection: 'home',
    });
    sectionControl.registerSection('home', new Home());
    sectionControl.registerSection('about', new About());
    sectionControl.registerSection('carol', new Carol());
    sectionControl.registerSection('kree', new Kree());
    sectionControl.registerSection('skrull', new Skrull());
    sectionControl.registerSection('fury', new Fury());
    this.mm = new Multimedia();
    sectionControl.registerSection('multimedia', this.mm);
    sectionControl.registerSection('guestbook', new Guestbook());
    new Footer();
    Resizer.force();
    if (window.location.hash) {
      window.location.href = window.location.hash;
    }
    if (SoundPlayer.isMuted()) {
      document.querySelector('.soundIcon').classList.add('muted');
    }
  }

  enterSite() {}

  setReleaseDate(dateList, settingsObj) {
    const now = new Date();
    if (window.location.search.indexOf('theatrical')) {
      settingsObj.releaseDate = dateList.find((o) => (o.date === 'default' ? o : false));
      return;
    }
    const result = dateList.find((o) => (o.date === 'default' || new Date(Date.parse(o.date)) <= now ? o : false));
    settingsObj.releaseDate = result;
  }

  /**
   *
   * Focus / blur
   *
   */

  initFocusBlur() {
    document.addEventListener('visibilitychange', () => {
      document.hidden ? this.onExitLink() : this.handleWindowFocus();
    });
  }

  handleWindowFocus() {
    Sounds.appUnmute();
  }

  onExitLink() {
    this.mm.pauseVideo();
    Sounds.appMute();
  }

  onSoundChange(e) {
    if (e.byUser) {
      document.querySelector('.soundIcon').classList.add('muted');
    } else {
      document.querySelector('.soundIcon').classList.remove('muted');
    }
  }
}

export default App;
